
<template>
  <van-action-sheet v-model="opened">
    <div class="record-ui">
      <div class="timing">
        {{ (duration * 1000) | formatDatetime('mm:ss') }}
      </div>
      <div class="time-tip">
        {{ duration > 50 ? `还可以说${60 - duration}秒` : `最长录音60秒` }}
      </div>

      <div class="btn-wrap" :class="[isrecording ? 'active' : '']" @click="click">
        <div class="touch-inside_s"></div>
      </div>

      <div class="tip">
        {{ !isrecording ? '点击开始录音' : '点击结束录音' }}
      </div>
    </div>
  </van-action-sheet>
</template>

<script>
import Record from '../record-class/record.js';

export default {
  name: 'voice-record',
  components: {},
  props: ['type'],
  data() {
    return {
      opened: false,
      // 是否正在录音
      isrecording: false,
      // 录音对像实例
      instance: null,
      // 录了多长时间
      duration: 0,
      // 播放倒计时
      playTime: 0,
      _resolve: null,
      // 录音的结果
      result: null,
      // 是否正在播放
      isplaying: false,
    };
  },
  methods: {
    goClose() {
      // 如果正在录音中，或者已经录完,则不允许点击模态来关闭
      if (!this.isrecording && !this.result) {
        this.close();
      }
    },
    click() {
      if (!this.isrecording) {
        this.startRecord();
      } else {
        this.stopRecord();
      }
    },
    startRecord() {
      this.isrecording = true;
      this.instance = new Record({
        event: {
          start: e => {
            this.isrecording = true;
          },
          countdown: (e, s) => {
            this.duration = Record.config.countdownTime - s;
          },
          // 录音到期自动停止时，也发送语音
          endAuto: (e, rest) => {
            this.uploadAndSubmit(rest);
          },
          end: (e, rest) => {
            // console.log("录音完成....");
            this.uploadAndSubmit(rest);
          },
          endShort: (e, time) => {
            vant.Toast('说话时间太短...');
            this.uploadAndSubmit();
          },
        },
      });
    },
    stopRecord() {
      // 停止录音
      this.instance.stop();
    },
    async uploadAndSubmit(rest) {
      this.isrecording = false;
      this.playTime = this.duration;
      // 录音时间太短
      if (!rest) return;

      this.close();

      // 在app环境下
      if (app.base.env == 'xgj') {
        this.uploadAndSubmit_App(rest);
      } else {
        // 在微信相关环境下
        this.uploadAndSubmit_WX(rest);
      }
    },
    showLoading() {
      vant.Toast.loading({
        message: '上传中...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: true,
        duration: 0,
      });
    },
    async uploadAndSubmit_App(rest) {
      this.showLoading();
      try {
        let ret = await xgjzt.oss.uploadFiles({
          platform: 'xgj',
          options: {
            file: rest.file,
            config: {
              image: {
                compress: false,
              },
            },
          },
        });
        this.result = ret;
        this.sumbit();
        vant.Toast.clear();
      } catch (error) {
        vant.Toast.clear();
        vant.Toast.fail('上传失败');
      }
    },
    // 在微信相关环境下
    async uploadAndSubmit_WX(rest) {
      let audioLocalId = rest.localId;
      this.showLoading();
      try {
        let serverId = await app.sdk.uploadVoice({
          localId: audioLocalId,
        });

        this.result = {
          env: app.base.env,
          type: 'audio',
          localId: audioLocalId,
          serverId: serverId,
          duration: this.duration,
        };
        this.sumbit();
        vant.Toast.clear();
      } catch (error) {
        vant.Toast.clear();
        vant.Toast.fail('上传失败');
      }
    },
    close() {
      this.opened = false;
    },
    sumbit() {
      this._resolve(this.result);
    },
    show() {
      return new Promise((resolve, reject) => {
        this._resolve = resolve;
        this._reject = reject;
      });
    },
  },
  created() {
    // 有可能此时，正有语音在播放中，因些先调用停止播放
    app.module.voice.stop();
  },
  mounted() {
    this.opened = true;
  },
  watch: {
    opened: function () {
      if (this.opened === false) {
        app.module.voice.stop();
        this.instance.stop();
      }
    },
  },
};
</script>


<style scoped lang="scss">
.record-ui {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  .timing {
    font-size: var(--fs-ex1);
    line-height: var(--lh-ex1);
    color: var(--g8);
    padding-bottom: calc(var(--gap) * 8);
  }
  .time-tip {
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    color: var(--g6);
  }

  .btn-wrap {
    margin: 24px 0;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    box-shadow: 0px 5px 12px 0px #eef0f2;
    display: flex;
    justify-content: center;
    align-items: center;
    .touch-inside_s {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      background-color: #2eaaf7;
      transition: all 0.3s ease-in-out;
    }
    &.active {
      animation-name: glow;
      animation-duration: 1.5s;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
      .touch-inside_s {
        width: 36px;
        height: 36px;
        border-radius: 8px;
      }
    }
    @keyframes glow {
      0% {
        box-shadow: 0 0 0 0 #eef0f2;
      }
      50% {
        box-shadow: 0 0 0 15px #eef0f2;
      }
      100% {
        box-shadow: 0 0 0 0 #eef0f2;
      }
    }
  }

  .tip {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g7);
  }
}
</style>